/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import swal from 'sweetalert';

import AdvancedSelect from '../../../elements/formElements/AdvancedSelect';
import FormFileGroup from '../../../elements/formElements/FormFileGroup';
import FormGroupText from '../../../elements/formElements/FormGroupText';
import FormGroupTextEditor from '../../../elements/formElements/FormGroupTextEditor';
import SubmitButton from '../../../elements/formElements/SubmitButton';
import axios from '../../../services/MyAxios';
import { API_CASINO_UPLOAD_PNG_IMAGE } from '../Helpers/CrmApiUrls';

function BonusPageForm({ apiUrl, returnUrl, handleSubmit, errors }) {
    const history = useHistory();
    const { id } = useParams();

    const [bonusPage, setBonusPage] = useState({
        title: '',
        slug: '',
        text: '',
        language_id: 1,
        translation_id: null,
        image_path: '',
    });

    const [languages, setLanguages] = useState([]);
    const [translations, setTranslations] = useState([]);

    if (id && id !== 0) {
        useEffect(() => {
            const url = `${apiUrl}/${id}`;
            axios
                .get(url)
                .then((response) => {
                    setBonusPage(response.data);
                })
                .catch((error) => {
                    if (error.response.status && error.response.status === 404) {
                        history.push({
                            pathname: returnUrl,
                        });
                    }
                });
        }, []);
    }

    const onChange = (e) => {
        const { value, name } = e.target;

        setBonusPage({
            ...bonusPage,
            [name]: value,
        });
    };

    const getLanguages = () => {
        axios.get('/crea/api/languages').then((response) => {
            setLanguages(response.data);
        });
    };

    const getTranslations = () => {
        axios.get(`${apiUrl}/translations`).then((response) => {
            setTranslations(response.data);
        });
    };

    const handleEditorChange = (text) => {
        setBonusPage({ ...bonusPage, text });
    };

    useEffect(() => {
        getLanguages();
        getTranslations();
    }, []);

    const uploadImage = (image) => {
        axios
            .post(
                API_CASINO_UPLOAD_PNG_IMAGE,
                { image, dir: 'deposit-bonus' },
                {
                    headers: {
                        Accept: 'application/json',
                        'content-type': 'multipart/form-data',
                    },
                }
            )
            .then((response) => {
                const url = response.data.url;
                setBonusPage({
                    ...bonusPage,
                    image_path: url,
                });
            })
            .catch(() => {
                swal({
                    title: 'Error',
                    text: 'Server error',
                    icon: 'error',
                });
            });
    };

    return (
        <div className="card">
            <div className="card-body">
                <form className="form-flex">
                    <FormGroupText
                        name="title"
                        label="Title"
                        required
                        value={bonusPage.title}
                        handleChange={onChange}
                        error={errors.title ?? undefined}
                        inputClasses="w-80"
                    />
                    <FormGroupText
                        name="slug"
                        label="Slug"
                        required
                        value={bonusPage.slug}
                        handleChange={onChange}
                        error={errors.slug ?? undefined}
                        inputClasses="w-80"
                    />

                    <AdvancedSelect
                        field="language_id"
                        value={bonusPage.language_id || 0}
                        label="Language"
                        options={languages}
                        optionAccessor="name"
                        optionValueAccessor="id"
                        required
                        error={errors.language_id ?? undefined}
                        handleChange={onChange}
                        inputClasses="w-80"
                    />

                    <AdvancedSelect
                        field="translation_id"
                        value={bonusPage.translation_id || 0}
                        label="This is translation of"
                        options={translations}
                        optionAccessor="title"
                        optionValueAccessor="id"
                        required
                        error={errors.translation_id ?? undefined}
                        handleChange={onChange}
                        inputClasses="w-80"
                    />

                    <FormGroupTextEditor
                        field="text"
                        label="Text"
                        handleChange={handleEditorChange}
                        value={bonusPage.text}
                        required
                        error={errors.text ?? undefined}
                    />

                    <FormFileGroup
                        field="image_path"
                        value={bonusPage.image_path}
                        label="Image in .png format"
                        required
                        acceptExtensions=".png"
                        error={errors.image_path ?? undefined}
                        handleChange={(event) => {
                            uploadImage(event.target.files[0]);
                        }}
                    />

                    <SubmitButton
                        label="Save"
                        onClick={(e) => {
                            e.preventDefault();
                            handleSubmit(bonusPage);
                        }}
                    />
                </form>
            </div>
        </div>
    );
}

export default BonusPageForm;
